var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 42,
    viewBox: "0 0 54 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b61601c171c75bac5ceacdb8465d3194",
    d: "M3.455,22.765H18.182a2.463,2.463,0,0,0,2.455-2.471V5.471A2.463,2.463,0,0,0,18.182,3H3.455A2.463,2.463,0,0,0,1,5.471V20.294a2.463,2.463,0,0,0,2.455,2.471ZM5.91,7.941h9.818v9.882H5.91Zm46.636,2.471H28a2.471,2.471,0,0,0,0,4.941H52.545a2.471,2.471,0,0,0,0-4.941Zm0,24.706H28a2.471,2.471,0,0,0,0,4.941H52.545a2.471,2.471,0,0,0,0-4.941ZM8.222,45h.029a2.446,2.446,0,0,0,1.718-.714L19.9,34.4a2.476,2.476,0,0,0-1-4.268,2.445,2.445,0,0,0-2.436.755L8.293,39.016,5.22,35.8a2.444,2.444,0,0,0-3.472-.058,2.483,2.483,0,0,0-.058,3.495l4.8,5.018A2.447,2.447,0,0,0,8.222,45Z",
    transform: "translate(-1 -3)",
    fill: "#74613c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusReport);
export default __webpack_public_path__ + "static/media/status-report.b539f6da80887a9934db765f8a6acf8b.svg";
export { ForwardRef as ReactComponent };